(function (window, $) {
  window.Acr = window.Acr || {};
  var Acr = window.Acr;
  var Ut = window.Utility;

  Acr.boxParallax = (function ($) {
    var parallaxSelector = '[data-box-parallax]';
    var pElSel = '[data-box-content]';
    var pElDOMRefI = {};
    var parallaxElements = [];
    var registeredAnimationFrames = [];
    var goParallax = !((Ut.isMobile() || Ut.isIE() || Ut.isTablet()));

    var initialWidth;

    var init = function () {
      initialWidth = window.innerWidth || document.documentElement.clientWidth;
      var cssSelector = parallaxSelector;

      clearAnimationFrames();
      $(window).off('scroll', addAnimationFrame);

      if ($(cssSelector).length) {
        var wProps = getwProps();
        pElDOMRefI = {};

        $(cssSelector).each(function (index, el) {
          var parallaxElement = {};
          parallaxElement.element = $(el);
          parallaxElements.push(parallaxElement);

          var $pEl = parallaxElement.element;

          $pEl
            .addClass('acr-box-parallax')
            .children(pElSel).addClass('acr-box-parallax-element');

          pElDOMRefI[index] = $pEl.find(pElSel);

          if (goParallax) {
            moveElement(pElDOMRefI[index], wProps.wTop, wProps.wHeight);
          }
        });

        $(window).resize(function (event) {
          var cW = window.innerWidth || document.documentElement.clientWidth;
          if (initialWidth !== cW) {
            initialWidth = cW;
            goParallax = true;
            var wProps = getwProps();
            $.each(parallaxElements, function (index, parallaxElement) {
              if (goParallax) {
                var $pEl = parallaxElement.element;
                moveElement(pElDOMRefI[index], wProps.wTop, wProps.wHeight);
              }
            });
          }
        });

        if (goParallax) {
          $(window).scroll(addAnimationFrame);
        }
      }
    };

    var getElementBoundingRect = function (Ele) {
      var rect = Ele[0].getBoundingClientRect();
      var win = window;
      var doc = document;
      var results = {
        rect: rect,
        inViewport: false,
      };
      if (rect.bottom >= 0
        && rect.top <= (win.innerHeight || doc.documentElement.clientHeight)) {
        results.inViewport = true;
      }
      return results;
    };

    var moveElement = function ($pEl, wTop, wHeight) {
      var elementRect = getElementBoundingRect($pEl);
      if (elementRect.inViewport) {
        var bgBladeTopPos = $pEl.offset().top;
        var slashHeight = elementRect.rect.height;
        var bghHeight = slashHeight * 1.2;
        var maxOffset = (slashHeight - bghHeight) + 2;
        var bgSpeed = $pEl.data('box-speed') ? $pEl.data('box-speed') : 30;
        var doReverse = !!$pEl.data('box-reverse');
        bgSpeed = -Math.abs(bgSpeed);
        var offset = ((wTop - bgBladeTopPos) / slashHeight) * bgSpeed;
        offset = Math.max(offset, maxOffset);
        if (doReverse) {
          offset *= -1;
        }

        $pEl.css({ transform: 'translate3d(0px,' + offset + 'px, 0px)' });
      }
    };

    var sHandler = function () {
      var wProps = getwProps();
      $.each(parallaxElements, function (index, parallaxElement) {
        if (goParallax) {
          moveElement(pElDOMRefI[index], wProps.wTop, wProps.wHeight);
        }
      });
    };

    var addAnimationFrame = function () {
      registeredAnimationFrames.push(window.requestAnimationFrame(sHandler));
    };

    var getwProps = function () {
      return {
        wTop: $(window).scrollTop(),
        wHeight: $(window).height(),
      };
    };

    var clearAnimationFrames = function () {
      $.each(registeredAnimationFrames, function (index, requestID) {
        window.cancelAnimationFrame(requestID);
      });
      registeredAnimationFrames = [];
    };

    var destroy = function () {
      parallaxElements = [];
      $(window).off('scroll', addAnimationFrame);
      clearAnimationFrames();
      if (pElDOMRefI) {
        $.each(pElDOMRefI, function (k, v) {
          pElDOMRefI[k] = null;
        });
        pElDOMRefI = null;
      }
    };

    return {
      init: init,
    };
  }($));

}(window, jQuery));
